"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnComment = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../../../Icon");
const Tooltip_1 = require("../../../../../Tooltip");
const ColumnComment = () => {
    return {
        id: 'comment',
        Header: '',
        Cell: ({ row }) => {
            const { comment, reservation } = row.original;
            const tooltipTextRows = [
                ...reservation.comment ? [reservation.comment] : [],
                ...comment ? [comment] : [],
            ];
            return tooltipTextRows.length > 0
                ? (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: ['white', 'left-aligned'], text: react_1.default.createElement(react_1.default.Fragment, null, tooltipTextRows.map((text, idx) => (react_1.default.createElement("div", { key: idx, className: 'tooltip__comment', dangerouslySetInnerHTML: { __html: text.replace(/(?:\r\n|\r|\n)/g, '<br>') } })))) },
                    react_1.default.createElement(Icon_1.Icon, { name: 'speech-bubble' })))
                : null;
        },
        headerClasses: ['table__selection'],
    };
};
exports.ColumnComment = ColumnComment;
//# sourceMappingURL=index.js.map